import { z } from "zod";
import { createEndpoint } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import {
    RedirectLookupResponseSchema,
} from "../schemas/redirect";

export interface RedirectLookupQueryParams extends QueryParams {
    path: string;
}

export function createPublicRedirectsApi(http: HttpClient, baseUrl: string) {
    const publicRedirectsBaseUrl = `${baseUrl}/public/redirects`;

    return {
        /**
         * Lookup redirect for a given path
         * GET /api/v2/public/redirects/lookup?path=/old-page
         */
        lookup: createEndpoint<
            z.infer<typeof RedirectLookupResponseSchema>,
            unknown,
            RedirectLookupQueryParams
        >(http, "GET", "/lookup", {
            base: publicRedirectsBaseUrl,
            responseSchema: RedirectLookupResponseSchema,
        }),
    };
}

